<script>
	export default {
		onLaunch: function() {
			// this.init()
			this.initRegister()
		},
		onShow: function() {
			console.log('App Show')
		},
		onHide: function() {
			console.log('App Hide')
		},
		methods: {
			async initRegister() {
				let fullURL = window.location.href.substring(0, window.location.href.lastIndexOf('#'))
				console.log(fullURL)
				let resData = await this.$u.api.getQwSignature({ url: fullURL })
				if (resData.code === 200) {
					this.$ww.register({
						corpId: 'wwe02e8fd876f8add1',
						agentId: '1000095',
						jsApiList: [
							'initOpenData',
							'selectEnterpriseContact',
							'chooseImage',
							'uploadImage'
						],
						getConfigSignature: (url) => {
							console.log(this.$ww.getSignature(resData.data.ticket))
							return this.$ww.getSignature(resData.data.ticket)
						}
					})
					console.log(this.$ww)
					this.$ww.initOpenData({
						success: (res) => {
							console.log('success', res)
						},
						fail: (err) => {
							console.log('fail', err)
						}
					})
				}
			}
			// async init() {
			// 	// ShiXuHui GuoJiWenWu
			// 	if (!this.$store.state.userInfo) {
			// 		let res = await this.$u.api.login({ code: 'GuoJiWenWu' })
			// 		if (res.code === 200) {
			// 			this.$store.commit('setUserInfo', res.data)
			// 		}
			// 	}
			// 	return
			// 	let code = this.getQueryVariable('code')
			// 	if (code) {
			// 		if (!uni.getStorageSync('code')) {
			// 			uni.setStorageSync('code', code);
						
			// 			let res = await this.$u.api.login({ code: code })
			// 			if (res.code === 200) {
			// 				this.$store.commit('setUserInfo', res.data)
			// 				this.initRegister()
							
			// 				// 判断是否跳转详情
			// 				let url = window.location.href
			// 				if (url.indexOf('state=') !== -1 && url.indexOf('#') !== -1) {
			// 					let value = url.substring(url.indexOf('state=') + 6, url.indexOf('#')).split('_')
			// 					console.log(value)
			// 					if (value[0] !== '') {
			// 						if (value[0] == 0) {
			// 							uni.navigateTo({
			// 								url: `/pages/details_she/details_she?id=${value[1]}`
			// 							})
			// 						} else if (value[0] == 1) {
			// 							uni.navigateTo({
			// 								url: `/pages/details_dca/details_dca?id=${value[1]}&isShow=true`
			// 							})
			// 						} else if (value[0] == 3) {
			// 							uni.navigateTo({
			// 								url: `/pages/workOrder_she/workOrder_she?id=${value[1]}`
			// 							})
			// 						}
			// 					}
			// 				}
			// 			}
			// 		} else if (uni.getStorageSync('code') !== code) {
						
			// 			uni.setStorageSync('code', code);
						
			// 			let res = await this.$u.api.login({ code: code })
			// 			if (res.code === 200) {
			// 				this.$store.commit('setUserInfo', res.data)
			// 				this.initRegister()
							
			// 				// 判断是否跳转详情
			// 				let url = window.location.href
			// 				if (url.indexOf('state=') !== -1 && url.indexOf('#') !== -1) {
			// 					let value = url.substring(url.indexOf('state=') + 6, url.indexOf('#')).split('_')
			// 					console.log(value)
			// 					if (value[0] !== '') {
			// 						if (value[0] == 0) {
			// 							uni.navigateTo({
			// 								url: `/pages/details_she/details_she?id=${value[1]}`
			// 							})
			// 						} else if (value[0] == 1) {
			// 							uni.navigateTo({
			// 								url: `/pages/details_dca/details_dca?id=${value[1]}&isShow=true`
			// 							})
			// 						} else if (value[0] == 3) {
			// 							uni.navigateTo({
			// 								url: `/pages/workOrder_she/workOrder_she?id=${value[1]}`
			// 							})
			// 						}
			// 					}
			// 				}
			// 			}

			// 		} else {
			// 			// test.doumee.cn
			// 			// dmtest.ahapp.net
			// 			let loc_href = encodeURIComponent("https://test.doumee.cn/lianhelihua_web/")
						
			// 			let corpId = 'wweea8f71b54e3b835';
			// 			let agentId = '1000095';
									
			// 			let wxUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${corpId}&redirect_uri=${loc_href}&response_type=code&scope=snsapi_base&state=#wechat_redirect`
						
			// 			location.href = wxUrl;
			// 		}
			// 	} else {
			// 		let loc_href = encodeURIComponent("https://test.doumee.cn/lianhelihua_web/")
					
			// 		let corpId = 'wweea8f71b54e3b835';
			// 		let agentId = '1000095';
								
			// 		let wxUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${corpId}&redirect_uri=${loc_href}&response_type=code&scope=snsapi_base&state=#wechat_redirect`
					
			// 		location.href = wxUrl;
			// 	}
			// },
			// // 获取url参数
			// getQueryVariable(variable) {
			// 	var query = window.location.search.substring(1);
			// 	var vars = query.split("&");
			// 	for (var i = 0; i < vars.length; i++) {
			// 		var pair = vars[i].split("=");
			// 		if (pair[0] == variable) {
			// 			return pair[1];
			// 		}
			// 	}
			// 	return (false);
			// },
			// async initRegister() {
			// 	let fullURL = window.location.href.substring(0, window.location.href.lastIndexOf('#'))
			// 	console.log(fullURL)
			// 	let resData = await this.$u.api.getQwSignature({ url: fullURL })
			// 	if (resData.code === 200) {
			// 		this.$ww.register({
			// 			corpId: 'wweea8f71b54e3b835',
			// 			agentId: '1000095',
			// 			jsApiList: [
			// 				'initOpenData',
			// 				'selectEnterpriseContact',
			// 				'chooseImage',
			// 				'uploadImage'
			// 			],
			// 			getConfigSignature: (url) => {
			// 				console.log(this.$ww.getSignature(resData.data.ticket))
			// 				return this.$ww.getSignature(resData.data.ticket)
			// 			}
			// 		})
			// 		console.log(this.$ww)
			// 		this.$ww.initOpenData({
			// 			success: (res) => {
			// 				console.log('success', res)
			// 			},
			// 			fail: (err) => {
			// 				console.log('fail', err)
			// 			}
			// 		})
			// 	}
			// }
		}
	}
</script>

<style lang="scss">
	@import "uview-ui/index.scss";
</style>
